/**
 * lil-gui tabanli debug paneli denetleyicisi (tembel yuklenir).
 *
 * Engine.addGUIFolder buraya delege eder. lil-gui yalnizca ilk cagrida
 * dinamik import edilir; canvas'in parent'ina absolute olarak yerlesir.
 */
import type { Engine } from "../Engine";

export class EngineGuiController {
  private _gui?: any;

  constructor(private readonly _engine: Engine) {}

  async addFolder(name: string): Promise<any> {
    if (!this._gui) {
      const guiModule = await import("lil-gui");
      this._gui = new guiModule.GUI({
        container: this._engine.renderer.instance.domElement.parentElement!,
      });

      this._gui.domElement.style.position = "absolute";
      this._gui.domElement.style.top = "0px";
      this._gui.domElement.style.right = "0px";

      // Global stil sayfalarini shadow root'a tasima denemesi (TO-DO):
      const globalSheets = Array.from(document.styleSheets);
      if (globalSheets && globalSheets.length > 0) {
        const x = globalSheets[0];
        const sheet = new CSSStyleSheet();
        const css = Array.from(x.cssRules)
          .map((rule) => rule.cssText)
          .join(" ");
        sheet.replaceSync(css);
      }
    }
    return this._gui?.addFolder(name);
  }
}
